// Redux action types
export const SET = 'one-state-call-history/set';
export const RUN_REPORT = 'one-state-call-history/run-report';
export const FETCH_REPORT_RESULT = 'one-state-call-history/fetch-report-result';
export const INIT = 'one-state-call-history/init';